import React, { useEffect, useState } from 'react'

import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { fetchProfile } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from 'react-router-dom';
import { FaCopy } from 'react-icons/fa';
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { verifyKybRcReverseService } from '../../../Services/ApiTestService/apiTestService';
import { useService } from '../../../context/ServiceContext';

const VerifyRcReverse = () => {
    const [chassisNo, setchassisNo] = useState('');
    const [profileData, setProfileData] = useState('');
    const [rcData, setRcData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { serviceName } = useService();
    const handleSubmit = async () => {

        if (chassisNo === "") {
            showErrorToast('Chassis number is required.');
            return;
        }
        try {
            const payload = {
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                chassis_no: chassisNo
            }
            setIsLoading(true);
            let response = await verifyKybRcReverseService(payload);
            setIsLoading(false)
            if (response.status.code === 200) {
                setRcData(response.data || []);
                setchassisNo('')
                showSuccessToast(response.message || response.status.message || "Rc Reverse details completed successfully");
            } else {
                setRcData(null);
                showErrorToast(response.message || response.status.message || response.data.message || response.errors || "An unexcepted error occurs while fetching details")
            }

        } catch (error) {
            setIsLoading(false);
            showErrorToast('Something went wrong while rc reverse validation', error);
        }



    };
    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    return (
        <>
            {isLoading && <Loader />}
            <Header heading={serviceName} />
            <Seo title={serviceName} />

            <div>

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>
                <div className='flex items-center gap-2 py-2 bg-gray-100 shadow-sm'>

                    <div>
                        <InputWithLabel
                            label={"Chassis Number"}
                            placeholder={"Enter Chassis Number "}
                            required={true}
                            value={chassisNo}
                            onChange={(e) => setchassisNo(e.target.value)}
                        />

                    </div>



                    <div className='mt-4'>
                        <Button type={'button'} text={"Verify"} onClick={handleSubmit} />
                    </div>

                </div>

                <div>
                    {rcData !== null ?
                        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div><RCCard rcData={rcData} /></div>
                            <div>
                                <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">Api Response </h3>
                                <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(rcData)} />
                                    {JSON.stringify(rcData, null, 2)}
                                </pre>
                            </div>
                        </div>

                        : ""}
                </div>

                <RcInstructions />
            </div>
        </>
    );
};


const RcInstructions = () => {
    return (
        <div className="max-w-5xl mx-auto p-5 bg-white shadow-lg rounded-lg border border-gray-200">
            <h1 className="text-xl font-semibold mb-3 text-red-600 border-b pb-2"> RC Reverse Details   Instructions</h1>
            <ol className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">


                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Enter Chassis Number.</li>
                        <li>Make sure Chassis number should be correct . </li>
                        <li>Don't close or reload page until process is completed.</li>
                    </ul>
                </li>
                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Chassis number should be correct </li>
                        <li>Don't use any space in registration number</li>
                        <li>No spaces or symbols </li>
                    </ul>
                </li>
                <li>
                    <strong>Having Issues?</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Double-check Chassis Number.</li>

                    </ul>
                </li>

            </ol>
        </div>
    );
};







const RCCard = ({ rcData }) => {
    return (
        <div className="w-[350px] border shadow-xl rounded-md overflow-hidden font-sans bg-white">

            <div className="bg-gradient-to-r from-blue-500 via-white to-blue-900 p-2 flex justify-between items-center">
                <img src="" alt=" Logo" className="w-8 h-8" />

            </div>
            <p className='text-center font-bold '>{rcData?.maskedAdharNumber || "N/A"}</p>

            <div className="flex p-4">


                <div className="text-sm space-y-1">
                    <div><strong>Name:</strong> {rcData?.name}</div>
                    <div><strong>careOf:</strong> {rcData?.careOf}</div>
                    <div><strong>DOB:</strong> {rcData?.dob}</div>
                    <div><strong>Gender:</strong> {rcData?.gender}</div>
                    <div>
                        <strong>Address: </strong>{rcData?.address?.street_name + "," + rcData?.address?.city + "," + rcData?.address?.pincode + "," + rcData?.address?.state + "," + rcData?.address?.country}

                    </div>
                </div>

            </div>


        </div>
    );
};



export default VerifyRcReverse
